"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _api = require("../../helpers/api.js");
var _createAction = require("../../helpers/createAction.js");
var _constants = require("../../constants");
var updateActionConstants = {
  loadingConstant: _constants.MEMBER_GROUP_UPDATING,
  loadedConstant: _constants.MEMBER_GROUP_UPDATED,
  errorConstant: _constants.MEMBER_GROUP_UPDATE_ERROR
};
var MemberGroups = /*#__PURE__*/_createClass(function MemberGroups(api) {
  var _this = this;
  _classCallCheck(this, MemberGroups);
  this.memberGroupsFetch = (0, _createAction.createApiRequestAction)({
    getKey: function getKey() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        organizationId = _ref.organizationId,
        query = _ref.query,
        pageNumber = _ref.pageNumber;
      return "organizations/".concat(organizationId, "/member-groups?query=").concat(query, "&page=").concat(pageNumber);
    },
    request: function request(getState) {
      var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        organizationId = _ref2.organizationId,
        loadUsers = _ref2.loadUsers,
        organization = _ref2.organization,
        query = _ref2.query,
        pageNumber = _ref2.pageNumber,
        sortKey = _ref2.sortKey;
      var options = {
        params: {
          load_users: loadUsers,
          query: query,
          organization: organization,
          page: pageNumber,
          sort_key: sortKey
        }
      };
      return _this.api.get("".concat((0, _api.currentUserUrl)(getState()), "/organizations/").concat(organizationId, "/member_groups"), options);
    },
    loadingConstant: _constants.MEMBER_GROUPS_FETCHING,
    loadedConstant: _constants.MEMBER_GROUPS_FETCHED,
    errorConstant: _constants.MEMBER_GROUPS_FETCH_ERROR,
    paginationEndConstant: _constants.MEMBER_GROUPS_PAGINATED
  });
  this.memberGroupFetch = (0, _createAction.createApiRequestAction)({
    getKey: function getKey() {
      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        memberGroupId = _ref3.memberGroupId,
        loadUsers = _ref3.loadUsers;
      return "organizations/member-groups/".concat(memberGroupId, "?load_users=").concat(loadUsers);
    },
    request: function request(getState) {
      var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        memberGroupId = _ref4.memberGroupId,
        loadUsers = _ref4.loadUsers,
        fullMembers = _ref4.fullMembers;
      var options = {
        params: {
          load_users: loadUsers,
          full_members: fullMembers
        }
      };
      return _this.api.get("".concat((0, _api.selectedOrganizationUrl)(getState()), "/member_groups/").concat(memberGroupId), options);
    },
    loadingConstant: _constants.MEMBER_GROUP_FETCHING,
    loadedConstant: _constants.MEMBER_GROUP_FETCHED,
    errorConstant: _constants.MEMBER_GROUP_FETCH_ERROR
  });
  this.memberGroupUsersFetch = (0, _createAction.createApiRequestAction)({
    getKey: function getKey() {
      var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        organizationId = _ref5.organizationId,
        memberGroupId = _ref5.memberGroupId,
        pageNumber = _ref5.pageNumber,
        query = _ref5.query;
      return "organizations/".concat(organizationId, "/member_groups/").concat(memberGroupId, "/members?query=").concat(query, "&page=").concat(pageNumber);
    },
    request: function request(getState) {
      var _ref6 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        organizationId = _ref6.organizationId,
        memberGroupId = _ref6.memberGroupId,
        pageNumber = _ref6.pageNumber,
        query = _ref6.query;
      var options = {
        params: {
          page: pageNumber,
          query: query
        }
      };
      return _this.api.get("".concat((0, _api.currentUserUrl)(getState()), "/organizations/").concat(organizationId, "/member_groups/").concat(memberGroupId, "/members"), options);
    },
    loadingConstant: _constants.MEMBER_GROUP_USERS_FETCHING,
    loadedConstant: _constants.MEMBER_GROUP_USERS_FETCHED,
    errorConstant: _constants.MEMBER_GROUP_USERS_FETCH_ERROR,
    paginationEndConstant: _constants.MEMBER_GROUP_USERS_PAGINATED
  });
  this.memberGroupCreate = (0, _createAction.createApiRequestAction)({
    getKey: function getKey(organizationId) {
      return "organizations/".concat(organizationId, "/member-groups/create");
    },
    request: function request(getState, organizationId, params) {
      return _this.api.post("".concat((0, _api.currentUserUrl)(getState()), "/organizations/").concat(organizationId, "/member_groups"), {
        member_group: params
      });
    },
    loadingConstant: _constants.MEMBER_GROUP_CREATING,
    loadedConstant: _constants.MEMBER_GROUP_CREATED,
    errorConstant: _constants.MEMBER_GROUP_CREATE_ERROR
  });
  this.organizationUnloadMemberGroups = function () {
    return function (dispatch, getState) {
      var _getState = getState(),
        loadedAt = _getState.loadedAt,
        session = _getState.session;
      var organizationId = session.get('selected_organization_id');
      var key = _this.memberGroupsFetch.getKey({
        organizationId: organizationId,
        query: '',
        pageNumber: 1
      });
      var orgMemberGroupsLoaded = loadedAt.get(key);
      if (orgMemberGroupsLoaded) {
        dispatch({
          type: _constants.ORGANIZATION_UNLOAD_MEMBER_GROUPS,
          payload: {
            organizationId: organizationId
          }
        });
      }
    };
  };
  this.organizationUnloadMemberGroupUsers = function (classId) {
    return function (dispatch, getState) {
      var _getState2 = getState(),
        loadedAt = _getState2.loadedAt,
        session = _getState2.session;
      var organizationId = session.get('selected_organization_id');
      var memberGroupId = classId;
      var key = _this.memberGroupUsersFetch.getKey({
        organizationId: organizationId,
        memberGroupId: memberGroupId,
        pageNumber: 1
      });
      var orgMemberGroupsLoaded = loadedAt.get(key);
      if (orgMemberGroupsLoaded) {
        dispatch({
          type: _constants.ORGANIZATION_UNLOAD_MEMBER_GROUP_USERS,
          payload: {
            memberGroupId: memberGroupId
          }
        });
      }
    };
  };
  this.memberGroupUpdate = (0, _createAction.createApiRequestAction)(_objectSpread({
    getKey: function getKey(memberGroupId) {
      return "organizations/member-groups/".concat(memberGroupId, "/update");
    },
    request: function request(getState, memberGroupId, params) {
      return _this.api.patch("".concat((0, _api.selectedOrganizationUrl)(getState()), "/member_groups/").concat(memberGroupId), {
        member_group: params
      });
    }
  }, updateActionConstants));
  this.memberGroupAssociate = (0, _createAction.createApiRequestAction)(_objectSpread({
    getKey: function getKey(memberGroupId) {
      return "organizations/member-groups/".concat(memberGroupId, "/associate");
    },
    request: function request(getState, memberGroupId) {
      return _this.api.patch("".concat((0, _api.selectedOrganizationUrl)(getState()), "/member_groups/").concat(memberGroupId, "/associate"));
    }
  }, updateActionConstants));
  this.memberGroupArchive = (0, _createAction.createApiRequestAction)(_objectSpread({
    getKey: function getKey(memberGroupId) {
      return "organizations/member-groups/".concat(memberGroupId, "/archive");
    },
    request: function request(getState, memberGroupId) {
      return _this.api.patch("".concat((0, _api.selectedOrganizationUrl)(getState()), "/member_groups/").concat(memberGroupId, "/archive"));
    }
  }, updateActionConstants));
  this.memberGroupUnarchive = (0, _createAction.createApiRequestAction)(_objectSpread({
    getKey: function getKey(memberGroupId) {
      return "organizations/member-groups/".concat(memberGroupId, "/unarchive");
    },
    request: function request(getState, memberGroupId) {
      return _this.api.patch("".concat((0, _api.selectedOrganizationUrl)(getState()), "/member_groups/").concat(memberGroupId, "/unarchive"));
    }
  }, updateActionConstants));
  this.api = api;
});
var _default = exports.default = MemberGroups;